import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MenuList from '@mui/material/MenuList';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import { withStyles } from '@mui/styles';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { Link } from 'react-router-dom';
import { isSessionSwitchPathBlocked } from 'common/roles/adminAccess';

import {
    Input as InputIcon,
    AccountCircleOutlined as AccountIcon
} from '@mui/icons-material';
import palette from 'theme/palette';

const styles = theme => ({
    paper: {
        backgroundColor: theme.palette.background.default,
    },
    menuItem: {
        '&:focus': {
            backgroundColor: theme.palette.primary.light,
            '& $primary, & $icon': {
                color: palette.common.white
            },
        },
    },
    menuIcon: {
        marginRight: theme.spacing(1),
    },
    primary: {
        
    },
    listItemText: {
        padding: theme.spacing(0),
    },
    icon: {
        marginRight: theme.spacing(0.5),
    },
});

class AccountMenu extends Component {
    render() {
        const { classes, onSelect, handleSignOut } = this.props;
        return (
            <Paper className={classes.paper}>
                <MenuList>
                {!isSessionSwitchPathBlocked("/account") && (
<Link to="/account">
                    <MenuItem className={classes.menuItem} onClick={event => onSelect()}>
                        <ListItemIcon className={classes.icon}>
                            <AccountIcon />
                        </ListItemIcon>
                        <ListItemText classes={{ primary: classes.primary }} className={classes.listItemText} primary="My Account" />
                    </MenuItem>
                    </Link>
)}
                    <MenuItem className={classes.menuItem} onClick={event => handleSignOut()}>
                        <ListItemIcon className={classes.icon}>
                            <InputIcon />
                        </ListItemIcon>
                        <ListItemText classes={{ primary: classes.primary }} className={classes.listItemText} primary="Logout" />
                    </MenuItem>
                </MenuList>
            </Paper>
        );
    }
}

AccountMenu.propTypes = {
    classes: PropTypes.object.isRequired,
};

// defaultProps removed - class component

export default withStyles(styles)(AccountMenu);
